<template>
  <div>
    <div v-if="me.voip.status > 0" class="">
      <transition name="view">
        <div class="cursor_pointer chat-popup-right animated--grow-in"
             @click.prevent="open = !open"
             :style="open ? 'display: none;' : 'display: block;'"
             style=" right: 100px; bottom: 30px;">
          <div id="formulariowid-popup2">
            <div class="px-2 title-color">
              {{ getTranslations('expression_305') }}
            </div>
          </div>
        </div>
      </transition>
      <transition v-if="open" name="view">
        <div class="animated--grow-in chat-popup-right" id="FormAppWid" style="display: block;">
          <div id="formulariowid-popup">
            <div class="row">
              <div class="col-12 pt-4 text-center">
                <div class="pt-2">
                  <div class="avatar_content d-block">
                    <div style="width: 90px; height: 90px;"
                         class="pl-3 avatar">
                      <img style="min-width: 90px;
                                 min-height: 90px;
                                 z-index: 9;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;"
                           class="avatar-img mt-2"
                           :src="(me.voip.lead.avatar_url
                          ? me.voip.lead.avatar_url
                          : lead_avatar)"/>
                      <span style="min-width: 90px;
                                 min-height: 90px;
                                 margin-left: -90px;
                                 z-index: 8;
                                 display: flex;
                                 border-radius: 50%;
                                 align-items: center;
                                 justify-content: center;
                                 background-color: #eee;"
                            class="avatar-img mt-2">
                        <i class="bx bx-loader-alt bx-spin" style="font-size: 2rem; color: #bfbfbf;"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 pt-0 pb-0 text-center">
                <div>
            <span
              style="font-size: 22px; color: #353535; position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 500">
                {{ me.voip.lead.name }}
            </span>
                </div>
              </div>
              <div class="col-12 pt-0 text-center">
                <div class="text-gray-600"
                     style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                  <i class="bx bx-mobile"></i>
                  <span class=""
                        style="position: relative; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 500">
                    {{ me.voip.lead.phone }}
                  </span>
                </div>
              </div>
              <div v-if="me.voip.status === 1" class="col-12 pt-3 pb-4 text-center">
                <div class="animated--grow-in">
                  <span class="h3 bx-flashing text-gray-700">{{ getTranslations('expression_306') }}</span>
                </div>
              </div>
              <div v-if="me.voip.status === 2" class="col-12 pt-3 pb-2 text-center">
                <div class="animated--grow-in">
                  <small class="pb-1">
                    {{ getTranslations('expression_305') }}
                  </small>
                  <p class="pt-1">
                    <i class="bx bx-time mr-1"></i>
                    <span class="bx-flashing">
                      {{
                        me.voip.minutes.length === 1
                          ? `0${me.voip.minutes}`
                          : me.voip.minutes
                      }}:{{
                        me.voip.seconds.length === 1
                          ? `0${me.voip.seconds}`
                          : me.voip.seconds
                      }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="col-12 pt-2 pb-4 text-center">
                <div v-if="me.voip.status > 0" class="animated--grow-in">
                  <div class="btn btn-success border-0 shadow-sm rounded-0 px-3 py-2"
                       @click.prevent="endCall"
                       style="background-color: #e52121; font-family: 'Product Sans Medium Regular'">
                    <i class="fa fa-phone-slash mr-2"></i> {{ getTranslations('expression_307') }}
                  </div>
                </div>
                <div class="pt-2 cursor_pointer" v-if="me.voip.status === 2">
                  <small @click.prevent="setMute(false)" v-if="me.voip.mute">
                    <i class='bx bx-volume-mute pr-1'></i>
                    <span>{{ getTranslations('expression_308') }}</span>
                  </small>
                  <small @click.prevent="setMute(true)" v-else>
                    <i class='bx bx-volume-full pr-1'></i>
                    <span>{{ getTranslations('expression_309') }}</span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <button id="open_button_right"
              @click.prevent="open = !open"
              class="open_button_right cursor_pointer">
        <i class="bx bxs-phone-call bx-flashing b-icones-wp"></i>
      </button>
    </div>
    <audio id="call" hidden autoplay></audio>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import lead_avatar from "../../assets/img/no-pic-user.png";

import {Actions, Config, Events} from '../../assets/js/api4com/verto/verto-gateway';
import '../../assets/js/api4com/verto/adapter-latest.js';
import '../../assets/js/api4com/verto/media-device-id.min.js';
import '../../assets/js/api4com/verto/jquery.json.min.js';
import '../../assets/js/api4com/verto/jquery.verto.js';
import '../../assets/js/api4com/verto/jquery.FSRTC.js';
import '../../assets/js/api4com/verto/jquery.jsonrpcclient.js';
import Timer from 'easytimer.js';

export default {
  name: "WidgetVoIP",
  data() {
    return {
      open: false,
      lead_avatar: lead_avatar,
    }
  },
  computed: {
    ...mapState(['chat', 'me', 'operators']),
    ...mapGetters([
      'getLeadObject',
      'getChannelObject',
      'getChatTicketObject',
    ]),
  },
  mounted() {
  },
  methods: {
    endCall() {
      Actions.hangup();
      if(this.me.voip.media) {
        this.sendVoip(`https://pbx.api4com.com/recordings/appbee.api4com.com/${this.getChannelObject('id', this.me.voip.lead.channel_id).integrations[10].data.branch}@appbee.api4com.com/${window.localStorage.getItem('callID')}.mp3`)
        this.me.voip.media = false;
      }
      Actions.logout();
      this.me.voip.status = 0;
    },
    setMute(payload) {
      this.me.voip.mute = payload;
      if (payload) {
        Actions.mute();
      } else {
        Actions.unmute();
      }
    },
    sendVoip(payload) {
      this.$store.dispatch('sendMessage', {
        file: payload,
        text: "voip|",
        channel_id: this.me.voip.lead.channel_id,
        ticket_id: this.getChatTicketObject('lead_id', this.me.voip.lead.id).id,
        operator_id: this.isOperator(this.getChatTicketObject('lead_id', this.me.voip.lead.id).department_id),
        department_id: this.getChatTicketObject('lead_id', this.me.voip.lead.id).department_id,
      })
    },
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.me.voip.lead.channel_id)
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
  }
}
</script>


<style src="../../assets/css/pages/chat.css" scoped/>
<style scoped>
* {
  box-sizing: border-box;
}

#formulariowid-popup {
  max-width: 300px;
}

/*Posição - Direita*/

.open_button_right {
  background-color: #05b173;
  color: white;
  /*padding: 10px 10px;*/
  padding: 10px 14px 5px 12px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  opacity: 1;
  position: fixed;
  right: 30px;
  width: 60px;
  height: 60px;
  bottom: 30px;
  box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1);
  z-index: 9;
}

.chat-popup-right:hover {
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.19), 0 4px 33px rgba(0, 0, 0, 0.22);
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  transition: .3s all ease;
}

.chat-popup-right {
  display: none;
  right: 30px;
  border: 0;
  position: fixed;
  box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  background: #fff;
  padding: 20px;
  animation: slide-top .6s forwards;
  z-index: 9;
  bottom: 105px;
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  transition: .3s all ease;
}

.b-icones-wp {
  font-size: 36px;
}

.unit-4 .unit-4-icon .icon-wrap {
  width: 50px;
  height: 50px;
}

.unit-4 .unit-4-icon .icon-wrap {
  width: 40px;
  height: 40px;
  position: relative;
  border-radius: 50%;
  display: inline-block;
  background-color: #00d2b5;
  -webkit-box-shadow: 0 4px 20px -5px rgba(0, 210, 181, 0.4);
  box-shadow: 0 4px 20px -5px rgba(0, 210, 181, 0.4);
}

@media only screen and (max-width: 600px) {
  /*Posição - Direita*/
  .open_button_right {
    background-color: #56cbab;
    color: white;
    padding: 10px 10px;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    opacity: 1;
    position: absolute;
    right: 35px;
    width: 60px;
    height: 60px;
    top: 395px;
    box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1);
    z-index: 9;
  }

  .chat-popup-right:hover {
    box-shadow: 0 0 0 rgba(0, 0, 0, 0.19), 0 4px 33px rgba(0, 0, 0, 0.22);
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    transition: .3s all ease;
  }

  .chat-popup-right {
    display: none;
    right: 35px;
    border: 0;
    position: absolute;
    box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    background: #fff;
    padding: 20px;
    animation: slide-top .6s forwards;
    z-index: 9;
    top: 130px;
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    transition: .3s all ease;
  }


}
</style>
